import React from "react";

function ViewInWeb({ link }: any) {
  return (
    <a
      href={link}
      target="_blank"
      className="btn btn-primary waves-effect waves-light"
      style={{
        marginRight: "0.5rem",
        background: "transparent",
        color: "#0d6efd",
      }}
    >
      Ver en web
    </a>
  );
}

export default ViewInWeb;
